import { ActionType, CustomersParams } from './model'

import { ActionCallback } from '../model'

export const getCustomers = (payload: CustomersParams, callback?: () => void): ActionCallback => ({
  type: ActionType.GET_CUSTOMERS,
  payload,
  callback,
})
